<div class="wrapper">
  <span>{{ message }}</span>
  <button [mat-dialog-close]="true" color="accent" mat-raised-button>{{ 'BUTTONS.OK' | translate | uppercase }}</button>
</div>
